module.exports = __webpack_public_path__ + "static/media/Atendimento-psicologico.b3754235.jpg";